<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="data.currentPage"
    :page-sizes="
      data.total > 100 ? [20, 40, 80, 100, data.total] : [20, 40, 80, 100]
    "
    :page-size="data.pageSize"
    :total="data.total"
    layout="total, sizes, prev, pager, next, jumper"
    background
  >
  </el-pagination>
</template>

<script>
export default {
  name: 'pagination',
  props: ['data'],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleSizeChange(val) {
      this.$emit('change', 'size', val)
    },
    handleCurrentChange(val) {
      this.$emit('change', 'current', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.el-pagination {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  justify-content: center;
}
</style>